import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "marker" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import Tooltip from '@/components/Tooltip.vue';
import {
  computed,
  ref,
  useAttrs,
} from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck as falCheck,
  faInfoCircle as falInfoCircle,
} from '@fortawesome/pro-light-svg-icons';
import {
  faCheck as fasCheck,
  faCircle as fasCircle,
} from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    type: { default: 'ul' },
    icon: { default: 'fas fa-check' },
    iconColor: { default: 'dark' },
    fontSize: { default: 'regular' },
    items: { default: () => btoa(JSON.stringify([''])) },
    gridSize: { default: '1' },
    small: { type: Boolean }
  },
  setup(__props: any) {

library.add(falCheck, fasCheck, falInfoCircle, fasCircle);

const props = __props;

const isBigIcon = props.type === 'icon' && props.iconColor !== 'dark';

const attrs = useAttrs();

const tag = computed(() => (props.type === 'icon' ? 'ul' : props.type));
const list = ref<HTMLElement>();
const listItems = computed<string[]>(() => (Array.isArray(props.items) ? props.items : JSON.parse(atob(props.items))).filter((item: string | null) => `${item || ''}`.trim() !== ''));
const mapIcon = (iconString: string | undefined) => {
  if (iconString) {
    return iconString
      .replace('fas ', 'fa-solid ')
      .replace('fal ', 'fa-light ');
  }

  return 'fa-solid fa-check';
};
const mappedIcon = computed<string>(() => mapIcon(props.icon));
const getItemIcon = (listItem: string | string[]) => {
  if (Array.isArray(listItem) && listItem[2]) {
    return mapIcon(listItem[2]);
  }

  return mappedIcon.value;
};

const getContent = (item: string | string[]) => {
  if (Array.isArray(item)) {
    return item[0];
  }

  return item;
};

const hasInfoText = (item: string | string[]) => Array.isArray(item) && item.length >= 2 && item[1];
const getInfoText = (item: string | string[]) => (hasInfoText(item) ? item[1] : '');

const classes = computed(() => {
  const listClasses = [
    'io-list',
    `io-list--${props.type}`,
    `io-list--icon-${props.iconColor}`,
    `fs-${props.fontSize}`,
  ];

  if (typeof attrs.class === 'string') {
    listClasses.push(attrs.class);
  }

  if (props.type === 'icon' && props.iconColor !== 'dark') {
    listClasses.push('big-gap');
  }

  if (parseInt(props.gridSize, 10) === 2) {
    listClasses.push('io-list--grid');
  }

  if (props.small) {
    listClasses.push('small');
  }

  return listClasses;
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), {
    ref_key: "list",
    ref: list,
    class: _normalizeClass(classes.value)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItems.value, (item, inx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `list-item-${inx}`
        }, [
          _createElementVNode("span", _hoisted_1, [
            (_unref(isBigIcon))
              ? (_openBlock(), _createElementBlock("span", {
                  key: _ctx.icon,
                  class: _normalizeClass(["icon-bg", `icon-bg-${_ctx.iconColor}`])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["second-bg", `${_ctx.iconColor}`])
                  }, [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: getItemIcon(item)
                    }, null, 8, ["icon"])
                  ], 2)
                ], 2))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  (_ctx.type === 'icon')
                    ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                        key: 0,
                        icon: getItemIcon(item)
                      }, null, 8, ["icon"]))
                    : (_ctx.type === 'ul')
                      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 1,
                          icon: "fa-solid fa-circle"
                        }))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(inx + 1) + ".", 1))
                ]))
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["item", _ctx.iconColor !== 'dark' ? 'category-icon' : ''])
          }, [
            _createElementVNode("span", {
              innerHTML: getContent(item)
            }, null, 8, _hoisted_4),
            (hasInfoText(item))
              ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", {
                      innerHTML: getInfoText(item)
                    }, null, 8, _hoisted_5)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode("  "),
                    _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-info-circle" })
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})